import React, { useEffect, useState } from 'react'
import { Box, useTheme } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';
import MenuCustom from '../../menuCustom/menuCustom';
import { useAppContext } from '../../../App';

export default function MenuWithDrodown({
  id,
  items,
  title,
  addItemToPath = false,
  submenuItems = [],
  titleRedirectTo = "",
  itemRedirectTo = "",
  subitemRedirectTo = "",
  subItemPathById = false,
  renderSubmenuWhen = ['categorias'],
  customStyles = {},
  onTitleClick = () => null,
  setSelectedCategory = () => null,
}) {  
  const {selectedCategory, setModeFilter, setSearcherText, modeFilter} = useAppContext();
  const [openStep, setOpenStep] = useState(resetOpenStep());
  const theme = useTheme();
  const style = styles(theme, customStyles);
  const shouldRenderSubmenu = renderSubmenuWhen.includes(title.toLowerCase())
  
  function resetOpenStep (){
    return items.reduce((prev, curr, index) => {
        return ({
            ...prev,
            [curr.name]: false
        })
    }, {});
  }

  const toggleMainMenu = (category) => {    
    setOpenStep({
      ...resetOpenStep(),
      [category?.name]: !openStep[category?.name]
    });
  }
  
  const getCategoryStyles = (category) => {
    return ({
      ...style.menuItem,
      backgroundColor: openStep[category] && shouldRenderSubmenu ? theme.background.primary : theme.background.quaternary
    })
  }

  const handleLinkActions = (category) => {
    if(id === 'modalidad'){
      setModeFilter(category)
    }
    else{
      setSelectedCategory({...category})
      setSearcherText('')
      setModeFilter(null)
    }          
  }
  
  const highlighting = (nameRef) => {
    if(id !== 'modalidad'){
      return theme.color.text.secondary
    }else{
      return nameRef === modeFilter?.name?
      theme.color.text.tertiary : theme.color.text.secondary
    }
  }

  useEffect(() => {    
      toggleMainMenu(selectedCategory);
  }, [selectedCategory]);

  return (
    <div style={style.container}>
      <Link
        style={{...style.menuItem, ...customStyles.title}}
        to={titleRedirectTo}
        onClick={onTitleClick}
      >
        {title}
      </Link>
      <p style={style.itemSeparator}></p>
      {items.map((category, index) => (
        <div>
          <Box
            as="li"
            key={`${category}_${index}`}
            style={getCategoryStyles(category)}
            position="relative"
          >
            <Link 
              to={itemRedirectTo}
              onClick={() => handleLinkActions(category)}
              style={{
                ...style.categories, 
                color: highlighting(category.name)
              }}
            >
              {category.name} {shouldRenderSubmenu? (openStep[category.name]? <ChevronDownIcon/> : <ChevronRightIcon/>): null}
            </Link>
          </Box>
          { openStep[category.name] && shouldRenderSubmenu &&
            <MenuCustom
                id={id}
                items={submenuItems}
                itemRedirectTo={subitemRedirectTo}
                addItemToPath={addItemToPath}
                itemToPathById={subItemPathById}
                customStyles={{container: style.container, menuItem: style.submenuItem}}
            />
          }
          {items.length - 1 !== index && <p style={style.itemSeparator}></p>}
        </div>
      ))}
    </div>
  );
}

const styles = (theme, customStyles) => ({
  container: {
    ...customStyles.container
  },
  categories:{
    display:'flex',
    justifyContent: 'space-between', 
    alignItems:'center', 
    width: '100%',
    ...customStyles.categories
  },
  menuItem:{
    display: 'flex',
    margin: 0,
    padding:0,
    color: theme.color.text.primary,
    backgroundColor: theme.background.secondary,
    ...customStyles.menuItem
  },
  itemSeparator:{
    width: '90%',
    borderBottom: '1px solid #ddd',
    ...customStyles.separator
  },
  submenuItem:{
    display: 'flex',
    margin: 0,
    padding:0,
    color: theme.color.text.tertiary,
    backgroundColor: theme.background.quaternary,
  }
});